import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerInicio(): void {

  applicationModuleRegistry.register({
    entry: 'inicio',
    id: 'inicio',
    name: 'stipulator.inicio',
    route: APPLICATION_ROUTES.DASHBOARD,
    order: 1,
  });
}
